export default __webpack_public_path__ + "static/media/wom.7a2ba202.svg";